/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
// import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as action from '../action';
import * as c from '../constant';

function UpdateModal({
  item,
  setFormData,
  formData,
  createInput,
  createUploader,
  updateService,
  getServiceList,
  showService,
  history,
  updating,
}) {
  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    setFormData({
      is_active: _.get(item, 'attributes.is_active'),
      name: _.get(item, 'attributes.name'),
      link_url: _.get(item, 'attributes.link_url'),
      sequence: _.get(item, 'attributes.sequence'),
      icon_url: _.get(item, 'attributes.icon_url'),
    });
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      method: 'PUT',
      icon_url: formData.icon_url.cdnUrl
        ? formData.icon_url.cdnUrl
        : _.get(item, 'attributes.icon_url'),
    };
    return updateService(item.id, args, ({ data }) => {
      setModal({ isOpen: false });
      getServiceList();
      showService(item.id);
      history.push(`/e-wallet-services/${_.get(data, 'id')}`);
    });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (!_.isEmpty(item)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(item)) {
      OnSetFormData();
    }
  }, [item]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row d-flex justify-content-center">
          <div className="col-md-6">
            <div className="col-12">
              <label className="form-control-plaintext form-label">
                Icon:{' '}
                <span className="text-danger">
                  <i>Required</i>
                </span>
              </label>
            </div>
            <div className="col-12">
              <img
                className="w-100 rounded"
                src={
                  !_.isObject(_.get(formData, 'icon_url') || '')
                    ? _.get(formData, 'icon_url') || ImagePlaceholder
                    : _.get(formData, 'icon_url.cdnUrl') || ImagePlaceholder
                }
                alt=""
              />
            </div>
            <div className="col-12 form-group">
              {createUploader(
                { key: 'icon_url', label: 'Browse' },
                { required: true, imagesOnly: true }
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Name:' },
              {
                required: true,
                placeholder: 'Name',
                maxLength: '150',
              }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'link_url', label: 'Link:' },
              {
                required: true,
                placeholder: 'Link',
                maxLength: '150',
              }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'sequence', label: 'Sequence:' },
              {
                required: true,
                placeholder: 'Sequence',
                maxLength: '150',
                type: 'number',
              }
            )}
          </div>
          <div className="col-12 form-group">
            <label htmlFor="publish" className="form-label">
              Publish: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  item: PropTypes.instanceOf(Object).isRequired,
  updateService: PropTypes.instanceOf(Function).isRequired,
  getServiceList: PropTypes.instanceOf(Function).isRequired,
  showService: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  // UpdateInfo: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: _.get(api, `${c.SHOW_SERVICE}.item`) || {},
  updating: api.loading.indexOf(c.UPDATE_SERVICE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
